import { StoryblokAsset } from '@definitions/types/storyblokBaseTypes'

/**
 * Creates a mock StoryblokAsset with all required fields
 * @param overrides - Partial fields to override defaults
 * @returns Complete StoryblokAsset mock
 */
export function createStoryblokAsset(
  overrides: Partial<StoryblokAsset> = {}
): StoryblokAsset {
  return {
    alt: null,
    copyright: null,
    fieldtype: 'asset',
    id: 0,
    filename: null,
    name: '',
    title: null,
    focus: null,
    meta_data: {},
    source: null,
    is_external_url: false,
    is_private: false,
    src: '',
    updated_at: '',
    width: null,
    height: null,
    aspect_ratio: null,
    public_id: null,
    content_type: '',
    ...overrides,
  }
}
